import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-vbakommentar',
  templateUrl: './page-vbakommentar.component.html',
  styleUrls: ['./page-vbakommentar.component.scss']
})
export class PageVBAkommentarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
